<script setup lang="ts">
import type { Referenz } from '~/types/referenzen/Referenz'

const references = ref<Referenz[]>([
  {
    title: 'Industriemuseum Zeche Zollern',
    subtitle: 'Energetische Sanierung',
    images: ['/images/referenzen/Zeche_Zollern.jpeg'],
    client: 'LWL',
    city: 'Dortmund',
    year: '2025 -',
    size: '1.500 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: '3-Feld Sporthalle Schermbeck',
    subtitle: 'Energetische Sanierung',
    images: ['/images/referenzen/Sporthalle_1.jpg', '/images/referenzen/Sporthalle_2.jpg'],
    client: 'Gemeinde Schermbeck',
    city: 'Schermbeck',
    year: '2025 -',
    size: '3.500 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Betriebswerkstatt Verkehrsbetriebe Mannheim',
    subtitle: 'Erweiterung Betriebswerkstatt',
    images: ['/images/referenzen/rnv_logo.jpg'],
    client: 'MV Mannheimer Verkehr GmbH',
    city: 'Mannheim',
    year: '2025 -',
    size: '',
    service: 'Objektplanung lph 1-7'
  },
  {
    title: 'McFit',
    subtitle: 'Umbau Fitnessstudio',
    images: ['/images/referenzen/Mcfit.jpg'],
    client: 'privat',
    city: 'Aachen',
    year: '2025 -',
    size: '1.800 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Ausländeramt',
    subtitle: 'Umbau Büroﬂäche',
    images: ['/images/referenzen/AAmt.jpg'],
    client: 'privat',
    city: 'Aachen',
    year: '2025 -',
    size: '5.200 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Bayer',
    subtitle: 'Neubau Labor',
    images: [
      '/images/referenzen/Bayer1.jpg',
      '/images/referenzen/Bayer2.jpg',
      '/images/referenzen/Bayer3.jpg'
    ],
    client: 'Bayer',
    city: 'Monheim',
    year: '2024-2025',
    size: '1.800 BGF',
    service: 'Generalplanung lph 3-6'
  },
  {
    title: 'Nevermined',
    subtitle: 'Umbau Produktionshalle',
    images: [
      '/images/referenzen/Nevermined_1.jpg',
      '/images/referenzen/Nevermined_2.jpg',
      '/images/referenzen/Nevermined_3.jpg',
      '/images/referenzen/Nevermined_4.jpg',
      '/images/referenzen/Nevermined_5.jpg',
      '/images/referenzen/Nevermined_6.jpg',
      '/images/referenzen/Nevermined_7.jpg'
    ],
    client: 'Nevermined GmbH',
    city: 'Essen',
    year: '2024-2025',
    size: '3.500 BGF',
    service: 'Generalplanung lph 1-8'
  },
  {
    title: 'Parken in Mülheim',
    subtitle: 'Parkhaus',
    images: [
      '/images/referenzen/Parken1.jpg',
      '/images/referenzen/Parken2.jpg',
      '/images/referenzen/Parken3.jpg',
      '/images/referenzen/Parken4.jpg',
      '/images/referenzen/Parken5.jpg',
      '/images/referenzen/Parken6.jpg'
    ],
    client: 'privat',
    city: 'Mülheim a.d. Ruhr',
    year: '2023-2024',
    size: '',
    service: 'Objektplanung lph 1-5'
  },
  {
    title: 'Sparkasse Aachen',
    subtitle: 'Umbau neue Filiale',
    images: [
      '/images/referenzen/Sparkasse1.jpg',
      '/images/referenzen/Sparkasse2.jpg',
      '/images/referenzen/Sparkasse4.jpg',
      '/images/referenzen/Sparkasse5.jpg'
    ],
    client: 'Sparkasse Aachen',
    city: 'Aachen',
    year: '2023-2024',
    size: '',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Radiologie',
    subtitle: 'Neubau Radiologie',
    images: [
      '/images/referenzen/Radiologie1.jpg',
      '/images/referenzen/Radiologie2.jpg',
      '/images/referenzen/Radiologie3.jpg',
      '/images/referenzen/Radiologie4.jpg',
      '/images/referenzen/Radiologie5.jpg',
      '/images/referenzen/Radiologie6.jpg'
    ],
    client: 'privat',
    city: 'Mülheim a.d. Ruhr',
    year: '2022-2024',
    size: '',
    service: 'Objektplanung lph 1-5'
  },
  {
    title: 'Gesundheitsamt 2BA',
    subtitle: 'Umbau Büroﬂächen',
    images: [
      '/images/referenzen/Gesundheitsamt_2ba1.jpg',
      '/images/referenzen/Gesundheitsamt_2ba2.jpg',
      '/images/referenzen/Gesundheitsamt_2ba3.jpg',
      '/images/referenzen/Gesundheitsamt_2ba4.jpg'
    ],
    client: 'privat',
    city: 'Aachen',
    year: '2022-2023',
    size: '5.200 BGF',
    service: 'Generalplanung lph 1-8'
  },
  {
    title: 'Hansa 9',
    subtitle: 'Neubau Bürogebäude',
    images: [
      '/images/referenzen/Hansa9_1.jpg',
      '/images/referenzen/Hansa9_2.jpg',
      '/images/referenzen/Hansa9_3.jpg',
      '/images/referenzen/Hansa9_4.jpg',
      '/images/referenzen/Hansa9_5.jpg',
      '/images/referenzen/Hansa9_6.jpg',
      '/images/referenzen/Hansa9_7.jpg'
    ],
    client: 'Privat',
    city: 'Solingen',
    year: '2022 - 2023',
    size: '1.100 BGF',
    service: 'Generalplanung lph 1-8'
  },
  {
    title: 'Telekom Bonn',
    subtitle: 'Sanierung Kantinenküche',
    images: ['/images/referenzen/Planung.webp'],
    client: 'HANNES GmbH',
    city: 'Bonn',
    year: '2023',
    size: '500 BGF',
    service: 'Objektplanung lph 1-5'
  },
  {
    title: 'DOQ52',
    subtitle: 'Neubau Büroensemble mit PH',
    images: [
      '/images/referenzen/DOQ1.jpg',
      '/images/referenzen/DOQ2.jpg',
      '/images/referenzen/DOQ3.jpg',
      '/images/referenzen/DOQ4.jpg',
      '/images/referenzen/DOQ5.jpg',
      '/images/referenzen/DOQ6.jpg',
      '/images/referenzen/DOQ7.jpg',
      '/images/referenzen/DOQ8.jpg',
      '/images/referenzen/DOQ9.jpg'
    ],
    client: 'Köster',
    city: 'Mülheim an der Ruhr',
    year: '2022 - 2024',
    size: '14.600 BGF',
    service: 'Objektplanung lph 1-5'
  },
  {
    title: 'Seniorenwohnen 21',
    subtitle: 'Neubau Seniorenzentrum',
    images: [
      '/images/referenzen/senioren-min.webp',
      '/images/referenzen/SZ21_1.webp',
      '/images/referenzen/SZ21_2.webp',
      '/images/referenzen/SZ21_3.webp'
    ],
    client: 'Privat',
    city: 'Pulheim',
    year: '2020 - 2021',
    size: '6.500 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Gesundheitsamt 1BA',
    subtitle: 'Umbau Büroflächen',
    images: [
      '/images/referenzen/Gesundheitsamt_ba1_1.jpg',
      '/images/referenzen/Gesundheitsamt_ba1_2.jpg',
      '/images/referenzen/Gesundheitsamt_ba1_3.jpg',
      '/images/referenzen/Gesundheitsamt_ba1_4.jpg',
      '/images/referenzen/Gesundheitsamt_ba1_5.jpg',
      '/images/referenzen/Gesundheitsamt_ba1_6.jpg',
      '/images/referenzen/Gesundheitsamt_ba1_7.jpg'
    ],
    client: 'Privat',
    city: 'Aachen',
    year: '2021',
    size: '3.300 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Handwerkerhof Hilden',
    subtitle: 'Neubau Produktion/Lager',
    images: ['/images/referenzen/Planung.webp'],
    client: 'Privat',
    city: 'Hilden',
    year: '2021 - 2022',
    size: '2.600 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: "swb'21",
    subtitle: 'Neubau Büro mit Halle & Aussenanlagen',
    images: ['/images/referenzen/Planung.webp'],
    client: 'Privat',
    city: 'Mülheim an der Ruhr',
    year: '2020-2022',
    size: '4.000 BGF',
    service: 'Objektplanung lph 1-8'
  },
  {
    title: 'Quartiersentwicklung Heilig',
    subtitle: '',
    images: [
      '/images/referenzen/Heilig-min.webp',
      '/images/referenzen/Heilig_1.webp',
      '/images/referenzen/Heilig_2.webp'
    ],
    client: 'Privat',
    city: '',
    year: '',
    size: '20.000 BGF',
    service: 'lph0'
  },
  {
    title: 'Werkkontor',
    subtitle: '',
    images: [
      '/images/referenzen/Werkkontor_1.webp',
      '/images/referenzen/Werkkontor_2.webp',
      '/images/referenzen/Werkkontor_3.webp',
      '/images/referenzen/Werkkontor_4.webp',
      '/images/referenzen/Werkkontor_5.webp',
      '/images/referenzen/Werkkontor_6.webp',
      '/images/referenzen/Werkkontor_7.webp',
      '/images/referenzen/Werkkontor_8.webp',
      '/images/referenzen/Werkkontor_9.webp',
      '/images/referenzen/Werkkontor_10.webp'
    ],
    client: 'Öffentlich',
    city: 'Krefeld',
    year: '2016 - 2017',
    size: 'ca. 1.200 BGF',
    service: 'lph 1-8'
  },
  {
    title: 'Hofaue',
    subtitle: '',
    images: ['/images/referenzen/Hofaue_1.webp', '/images/referenzen/Hofaue_2.webp'],
    client: 'Projektentwickler',
    city: 'Wuppertal',
    year: '2010',
    size: '8.400 BGF',
    service: 'lph 1-4'
  }
])

// split refs into arrays of 4
const referencesArray = ref<Referenz[][]>([])
for (let index = 0; index < references.value.length; index += 4) {
  referencesArray.value.push(references.value.slice(index, index + 4))
}
</script>

<template>
  <div class="px-0 py-0 mx-0 my-0">
    <div class="pt-high">
      <v-row class="fill-height" no-gutters>
        <template v-for="(fragment, index) in referencesArray" :key="index">
          <ReferenzenGalleryRow :refs="fragment" />
        </template>
      </v-row>
    </div>
  </div>
</template>
